<template>
  <div id="game-wrapper" :class="{start: bStartScreen}" @click="bStartScreen = false" @touchstart.self.prevent="bStartScreen = false">
    <img id="donkey" src="../src/assets/esel.png" alt="" />
    <img id="title" src="../src/assets/title.jpg" alt="" />
    <div id="question">
      <h1>
        <span>
          {{question.text}}
        </span>
      </h1>
      <ul>
        <li v-for="answer in question.answers" :key="answer.id" :data-answer-id="answer.id" @click="onAnswerClick(answer.id)" @touchstart.self.prevent="onAnswerClick(answer.id)" :class="{current: (answer.id == selectedAnswerId)}">
          <span>{{ answer.text }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div :class="{popup: true, show: (answer.id == selectedAnswerId)}" v-for="answer in question.answers" :key="answer.id" @click="selectedAnswerId = 0" @touchstart.self.prevent="selectedAnswerId = 0" v-html="answer.popup"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Multiple-Choice',
  data () {
    return {
      bStartScreen: true,
      selectedAnswerId: 0,
      question: {
        text: 'Why did Jesus ride to Jerusalem on a donkey?',
        answers: [
          {
            id: 1,
            text: 'Because he missed the train!',
            popup: '<h2>Sadly not. </h2> <p>There were no trains at the time when Jesus lived so it can’t have been that. Try again!</p>'
          },
          {
            id: 2,
            text: 'His noble horse was injured.',
            popup: '<h2>Sadly not. </h2> <p>Only rich people could afford a noble riding horse in those days. And Jesus was very poor. Unfortunately, the horse won’t get you any further. Try again!</p>'
          },
          {
            id: 3,
            text: 'Donkeys were beasts of burden for the common people.',
            popup: '<h2>Yes, that’s right! </h2> <p>Because of their rather dull grey coats, low height and sometimes unpredictable nature, donkeys have always been mocked and their name often used to insult stupid people. <br>Jesus wanted to show that he’s not a rich and proud hero, but just as simple and humble as any other ordinary person.</p>'
          }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    onAnswerClick (id) {
      console.log('onAnswerClick()', id)
      this.selectedAnswerId = id
    }
  }
}
</script>
